import React from 'react';
import {
  FiSearch, FiGrid, FiPackage, FiShield, FiCheck, FiStar,
  FiLock, FiActivity, FiFileText, FiAward,
  FiShoppingBag, FiTruck, FiThermometer, FiHeart, FiTool, FiSun,
} from 'react-icons/fi';

export const FEATURED_WAREHOUSES = [
  {
    id: 'feat-1', name: 'Kumar Logistics Hub', city: 'Bhiwandi', state: 'Mumbai',
    warehouse_type: 'DRY', base_price: 18.5, avg_rating: 4.5, review_count: 23,
    available_area_sqft: 35000, amenities: ['CCTV', 'FIRE_SAFETY', 'LOADING_DOCK'],
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  },
  {
    id: 'feat-2', name: 'Kumar Cold Chain', city: 'Pune', state: 'Maharashtra',
    warehouse_type: 'COLD', base_price: 35.0, avg_rating: 4.8, review_count: 41,
    available_area_sqft: 15000, amenities: ['CCTV', 'FIRE_SAFETY', 'FORKLIFT'],
    gradient: 'linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%)',
  },
  {
    id: 'feat-3', name: 'Delhi Mega Warehouse', city: 'Delhi', state: 'Delhi NCR',
    warehouse_type: 'DRY', base_price: 22.0, avg_rating: 4.2, review_count: 67,
    available_area_sqft: 100000, amenities: ['CCTV', 'LOADING_DOCK', 'RACKING'],
    gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
  },
  {
    id: 'feat-4', name: 'Bangalore Tech Storage', city: 'Bangalore', state: 'Karnataka',
    warehouse_type: 'FULFILLMENT', base_price: 28.0, avg_rating: 4.6, review_count: 34,
    available_area_sqft: 35000, amenities: ['CCTV', 'FIRE_SAFETY', 'FORKLIFT', 'RACKING'],
    gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
  },
  {
    id: 'feat-5', name: 'Hyderabad Pharma Hub', city: 'Hyderabad', state: 'Telangana',
    warehouse_type: 'PHARMA', base_price: 45.0, avg_rating: 4.7, review_count: 19,
    available_area_sqft: 25000, amenities: ['CCTV', 'FIRE_SAFETY', 'LOADING_DOCK'],
    gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
  },
  {
    id: 'feat-6', name: 'Kolkata Cold Storage', city: 'Kolkata', state: 'West Bengal',
    warehouse_type: 'COLD', base_price: 30.0, avg_rating: 4.3, review_count: 28,
    available_area_sqft: 18000, amenities: ['CCTV', 'FIRE_SAFETY', 'FORKLIFT'],
    gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
  },
];

export const CATEGORIES = [
  { key: 'DRY', icon: '\uD83C\uDFE2', label: 'Dry Storage', count: '240+' },
  { key: 'COLD', icon: '\uD83E\uDDCA', label: 'Cold Storage', count: '85+' },
  { key: 'PHARMA', icon: '\uD83D\uDC8A', label: 'Pharma', count: '45+' },
  { key: 'FULFILLMENT', icon: '\u26A1', label: 'Fulfillment', count: '60+' },
  { key: 'AGRICULTURE', icon: '\uD83C\uDF3E', label: 'Agriculture', count: '55+' },
  { key: 'HAZMAT', icon: '\u2622\uFE0F', label: 'Hazardous', count: '15+' },
];

export const HOW_IT_WORKS = [
  { step: 1, icon: <FiSearch size={32} />, title: 'Search', desc: 'Browse warehouses by city, commodity type, area, and specific requirements.' },
  { step: 2, icon: <FiGrid size={32} />, title: 'Compare & Book', desc: 'Compare listings side by side, book space instantly or request host approval.' },
  { step: 3, icon: <FiPackage size={32} />, title: 'Store & Manage', desc: 'Track inventory, manage inbound/outbound shipments with full WMS tools.' },
];

// Default content for the Trust Signals cards. Admins can override
// every ``title`` and ``desc`` via ``landing_trust1_title`` / ``_desc``
// through ``landing_trust6_title`` / ``_desc`` in ``/settings/branding``;
// the public component checks those keys first and falls back to these
// defaults only when an override isn't set.
export const TRUST_SIGNALS = [
  {
    icon: <FiShield size={26} />, title: 'Verified Warehouses',
    desc: 'All listed warehouses are KYC verified with valid certificates.',
    stat: '100%', statLabel: 'KYC verified',
    highlight: 'Average approval in 48 hours',
  },
  {
    icon: <FiLock size={26} />, title: 'Escrow Protection',
    desc: 'Your payments are held in escrow until move-in confirmation.',
    stat: 'RBI', statLabel: 'compliant escrow',
    highlight: 'Funds released only on your green light',
  },
  {
    icon: <FiActivity size={26} />, title: 'Real-time Tracking',
    desc: 'Monitor your inventory 24/7 from anywhere on any device.',
    stat: '24/7', statLabel: 'live visibility',
    highlight: 'Mobile + web parity',
  },
  {
    icon: <FiFileText size={26} />, title: 'GST Compliant',
    desc: 'Auto-generated GST invoices with HSN/SAC codes included.',
    stat: 'GSTR', statLabel: '1 · 3B · 9 ready',
    highlight: 'Built for India-first compliance',
  },
  {
    icon: <FiAward size={26} />, title: 'Legal Contracts',
    desc: 'Digital contracts with Aadhaar eSign for instant execution.',
    stat: 'eSign', statLabel: 'Aadhaar-backed',
    highlight: 'Court-admissible audit trail',
  },
  {
    icon: <FiStar size={26} />, title: 'Rated & Reviewed',
    desc: 'Trust scores based on verified bookings and tenant feedback.',
    stat: '4.7★', statLabel: 'avg host rating',
    highlight: 'No paid placements',
  },
];

export const INDUSTRY_USE_CASES = [
  {
    key: 'ECOMMERCE', icon: <FiShoppingBag size={22} />,
    title: 'E-commerce & D2C',
    desc: 'Shopify, Amazon, Flipkart-ready fulfillment centers with same-day dispatch and returns processing.',
    points: ['Same-day pick & pack', 'Returns desk', 'Marketplace integrations'],
    searchType: 'FULFILLMENT',
  },
  {
    key: 'PHARMA', icon: <FiHeart size={22} />,
    title: 'Pharma & Healthcare',
    desc: 'Temperature-controlled, GMP-aligned warehouses with batch-level traceability and Schedule H compliance.',
    points: ['2°C–8°C / 15°C–25°C', 'Batch + expiry tracking', 'Drug license verified'],
    searchType: 'PHARMA',
  },
  {
    key: 'FMCG', icon: <FiPackage size={22} />,
    title: 'FMCG & Consumer Goods',
    desc: 'High-throughput dry storage with racking, dock-scheduling and pan-India distribution networks.',
    points: ['Multi-zone racking', 'Dock scheduling', 'Distribution-ready'],
    searchType: 'DRY',
  },
  {
    key: 'COLD_CHAIN', icon: <FiThermometer size={22} />,
    title: 'Cold Chain & Frozen',
    desc: 'Frozen, chilled and ambient cold rooms with 24×7 temperature monitoring and IoT-driven alerts.',
    points: ['-25°C to +25°C zones', 'IoT temperature alerts', 'Reefer dock access'],
    searchType: 'COLD',
  },
  {
    key: 'AGRI', icon: <FiSun size={22} />,
    title: 'Agriculture & Commodities',
    desc: 'WDRA-registered godowns for grains, pulses and produce with fumigation and weighbridge facilities.',
    points: ['WDRA-registered', 'Fumigation cycles', 'Weighbridge on-site'],
    searchType: 'AGRICULTURE',
  },
  {
    key: 'MANUFACTURING', icon: <FiTool size={22} />,
    title: 'Manufacturing & Industrial',
    desc: 'High-clearance dry storage with forklift access, heavy-duty racking and bonded options near ports.',
    points: ['Forklift / hydra access', 'Heavy-duty racking', 'Bonded warehousing'],
    searchType: 'DRY',
  },
];

export const SORT_OPTIONS = [
  { value: 'price_asc', label: 'Price: Low to High' },
  { value: 'price_desc', label: 'Price: High to Low' },
  { value: 'rating_desc', label: 'Rating: High to Low' },
  { value: 'distance_asc', label: 'Distance: Nearest' },
];

export const AMENITY_LABELS = {
  CCTV: 'CCTV', FIRE_SUPPRESSION: 'Fire Safety', LOADING_DOCK: 'Loading Dock',
  FORKLIFT: 'Forklift', RACKING: 'Racking', SECURITY_GUARD: 'Security',
  WEIGHBRIDGE: 'Weighbridge', FUMIGATION: 'Fumigation', EV_CHARGING: 'EV Charging',
};

export const TYPE_COLORS = {
  DRY: { bg: '#fff3e0', text: '#e65100' },
  COLD: { bg: '#e0f7fa', text: '#006064' },
  PHARMA: { bg: '#e8f5e9', text: '#1b5e20' },
  FULFILLMENT: { bg: '#e3f2fd', text: '#0d47a1' },
  HAZMAT: { bg: '#fce4ec', text: '#b71c1c' },
  BONDED: { bg: '#f3e5f5', text: '#4a148c' },
  OPEN: { bg: '#f1f8e9', text: '#33691e' },
};
